import { Box, TextField, Tooltip } from '@mui/material';
import React from 'react';
import type { JobListPropType } from 'src/components/types/types';

interface JobDetailsProps {
  jobDetails: JobListPropType;
}

const JobDetails: React.FC<JobDetailsProps> = ({ jobDetails }) => {
  // Create an array of label-value pairs
  const detailsArray = [
    { label: 'Job ID', value: jobDetails.jobID },
    { label: 'Request ID', value: jobDetails.requestID },
    { label: 'Request Date', value: new Date(jobDetails.requestDate).toLocaleDateString() },
    { label: 'Request Name', value: jobDetails.requestName },
    { label: 'Project Type', value: jobDetails.projectTypeName },
    { label: 'Job Type', value: jobDetails.jobTypeName },
    { label: 'Client ID', value: jobDetails.clientID },
    { label: 'Client Name', value: jobDetails.clientName ?? ' - ' },
    { label: 'Table Name', value: jobDetails.tableName },
    { label: 'Job Status', value: jobDetails.jobStatusName },
    { label: 'User Name', value: jobDetails.userName }
  ];

  return (
    <>
    <Box className="px-[16px] pt-[10px]  mb-[10px]">
  <TextField
    id="outlined-basic"
    label="Request ID"
    variant="outlined"
    fullWidth
    name="Description"
    value={jobDetails.requestID}
    autoComplete="off"
    InputProps={{
      style: {
        textAlign: 'center',
        color: '#000000',
        fontSize: '18px',
        fontWeight: '700',
        WebkitTextFillColor: '#000000',
        
      },
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#e0e0e0', // Gray background color
        '& fieldset': {
          borderColor: '#d0d0d0',
        },
        '&:hover fieldset': {
          borderColor: '#b0b0b0',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#D6242C',
        },
      },
      '& input': {
        textAlign: 'center',
        padding: '7px', // Adjust padding to fit within the TextField
        color: '#000000 !important',
        fontSize: '18px !important',
        fontWeight: '700 !important',
        '-webkit-text-fill-color': '#000000 !important',
        opacity: '1 !important',
        backgroundColor: '#f5f5f5 !important', // Ensure background color is applied
      },
      '& label': {
        textAlign: 'center',
        color: '#343434',
        top: '-6px', // Adjust label position to account for increased padding
      },
      '& label.Mui-focused': {
        color: '#D6242C',
      },
    }}
    InputLabelProps={{
      shrink: true,
    }}
    disabled
  />
</Box>
    <div className="bg-white rounded-md p-6">
       
      <div>
        {detailsArray.map((item, index) => (
          <div
            key={index}
            className={`flex items-center py-3 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
            style={{ borderBottom: '1px solid #DADADA' }}
          >
            {/* Label Column */}
            <div className="font-bold text-gray-900 w-1/3">
              {item.label}
            </div>
            {/* Spacer between Label and Value */}
            <div className="w-2" />
            {/* Value Column */}
            <div className="w-2/3">
              <Tooltip title={String(item.value)} placement="top">
                <span
                  className="text-gray-700 overflow-hidden overflow-ellipsis whitespace-nowrap"
                  style={{ maxWidth: 'calc(100% - 100px)' }}
                >
                  {item.value}
                </span>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default JobDetails;
